import uuidv4 from 'uuid/v4';

export default () => uuidv4();
